import DefaultAvatar2Icon from '@assets/default-avatar-2.webp';
import DefaultAvatarIcon from '@assets/default-avatar.webp';

import styles from './TelegramChatSettingsItem.module.css';

const { adminMessage, otherMessage } = styles;

export const getConditionalMessageDetails = (isAdminMessage: boolean, imageUrl: string | null) => {
  const messageClass = isAdminMessage ? adminMessage : otherMessage;
  const imageSrc = isAdminMessage ? DefaultAvatarIcon : imageUrl || DefaultAvatar2Icon;

  return { messageClass, imageSrc };
};
